<template>
    <div class="contest-container" v-loading="loading">
        <el-row  justify="space-between" :gutter="0">
            <el-col :xs="2" :sm="3" :md="4" :lg="5" :xl="6">
                <div style="height: 1px; width: 100%">
                </div>
            </el-col>
            <el-col :xs="20" :sm="18" :md="16" :lg="14" :xl="12">
                <div class="contest" align="center">
                    <div class="title">EQUIPOS</div>
                    <div class="short-desc"></div>

                    <div class="body">
                        <el-table :data="teams" height="250" style="width: 100%">
                            <el-table-column
                                prop="privacy"
                                label=""
                                align="center"
                                width="40">
                                <template slot="header" slot-scope="scope">
                                    <i class="el-icon-lock"></i>
                                </template>
                                <template slot-scope="scope">
                                    <i class="el-icon-unlock" v-if="scope.row.privacy == 'OPEN'"></i>
                                    <i class="el-icon-lock" v-if="scope.row.privacy == 'CLOSED'"></i>
                                </template>
                            </el-table-column>
                            
                            <el-table-column
                                prop="tag"
                                label="TAG"
                                align="center"
                                width="60">
                            </el-table-column>

                            <el-table-column
                                prop="name"
                                label="Nombre">
                                <template slot-scope="scope">
                                    <el-button @click="openTeam" type="text">{{scope.row.name}}</el-button>
                                    
                                </template>
                            </el-table-column>

                            <el-table-column
                                label="Miembros"
                                align="center"
                                width="90">
                                <template slot-scope="scope">
                                    {{scope.row.participants}}/{{scope.row.size}}
                                </template>
                            </el-table-column>

                            <el-table-column
                                label="Acciones"
                                align="center"
                                width="140">
                                <template slot-scope="scope">
                                    <el-button @click="joinTeam" :disabled="scope.row.participants == scope.row.size" size="small" plain>Unirse</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>

                    <div style="width: 100%">
                        <el-button class="join" @click="openCreate" type="primary" plain>
                                Crear equipo
                        </el-button>
                    </div>

                    <div class="footer">
                    </div>
                </div>
            </el-col>
            <el-col :xs="2" :sm="3" :md="4" :lg="5" :xl="6">
                <div style="height: 1px; width: 100%">
                </div>
            </el-col>
        </el-row>
        <el-dialog title="Crear equipo" :visible.sync="dialogCreateVisible" align="left" width="300px">
            <el-form :model="createTeamForm" :rules="rulesCreateTeamForm" label-position="top" ref="createTeamForm" label-width="120px" v-loading="loadingForm">
                <el-form-item label="Nombre" prop="name">
                    <el-input v-model="createTeamForm.name"></el-input>
                </el-form-item>
                <el-form-item label="TAG" prop="tag">
                    <el-input v-model="createTeamForm.tag" minlength="2" maxlength="4"></el-input>
                </el-form-item>
                <el-form-item label="Color" prop="color">
                    <el-color-picker v-model="createTeamForm.color"></el-color-picker>
                </el-form-item>
                <el-form-item label="Tamaño" prop="size">
                    <el-select v-model="createTeamForm.size" placeholder="Tamaño del equipo" style="width: 100%">
                        <el-option label="2" :value="2"></el-option>
                        <el-option label="3" :value="3"></el-option>
                        <el-option label="4" :value="4"></el-option>
                        <el-option label="5" :value="5"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="Privacidad" prop="privacy">
                    <el-select v-model="createTeamForm.privacy" placeholder="Privacidad del equipo" style="width: 100%">
                        <el-option label="Abierto, cualquiera puede entrar" value="OPEN"></el-option>
                        <el-option label="Cerrado, solo con contraseña" value="CLOSED"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="Contraseña" prop="password" v-show="createTeamForm.privacy == 'CLOSED'">
                    <el-input type="password" v-model="createTeamForm.password"></el-input>
                </el-form-item>
                <el-form-item style="text-align: center">
                    <el-button type="primary" @click="submitForm('createTeamForm')">Crear</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>

import axios from 'axios';

export default {
    name: 'Teams',
    props: {
        type: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            loading: false,
            dialogCreateVisible: false,
            teams: [
                {
                    id: 1,
                    name: "Pepes Team",
                    tag: "PPT",
                    color: "#00FF00",
                    participants: 5,
                    size: 5
                }
            ],
            loadingForm: false,
            createTeamForm: {
                name: "",
                tag: "",
                color: "#36FF00",
                size: 5,
                privacy: 'OPEN',
            },
			rulesCreateTeamForm: {
				name: [
					{ required: true, message: 'Ingrese un nombre', trigger: 'blur' },
					{ min: 5, message: 'El nombre tiene que tener al menos 5 caracteres', trigger: 'blur' }
				],
				tag: [
					{ required: true, message: 'Ingrese un TAG', trigger: 'blur' },
					{ min: 3, max: 4, message: 'El TAG tiene que tener entre 3 y 4 caracteres', trigger: 'blur' }
				],
				password: [
					{ required: true, message: 'Ingrese una contraseña', trigger: 'blur' },
					{ min: 5, message: 'La contraseña tiene que tener al menos 5 caracteres', trigger: 'blur' }
				],
				server: [
					{ required: true, message: 'Seleccione un servidor', trigger: 'change' }
				],
				summoner: [
					{ required: true, message: 'Ingrese su nombre de invocador', trigger: 'blur' }
				]
			}
        }
    },
    beforeMount() {
        this.loadTeams();
    },
    methods: {
        loadTeams(){
            this.loading = true;
            this.clearData();
            axios({
                method: 'POST',
                url: '/server/teams.php?action=get',
                data: {
                    id: this.$route.params.id
                }
            }).then((response) => {
                if(response.data.error != 0){
                    this.$notify.error({
                        title: 'Error',
                        message: response.data.message,
                        offset: 115
                    });
                } else {
                    //response.data.data;
                    this.teams = response.data.data
                }
            })
            .catch(this.catchAxios)
            .then(() => {
                this.loading = false;
            });
        },

        clearData(){
            this.id = -1;
        },
        getStyle(type){
            var obj = {};
            if(type.color != undefined && type.color != "") obj.color = type.color;
            return obj;
        },

        join(){
            if(!this.expired && !this.started){
                this.$router.push({ name: 'join-contest', params: { id: this.$route.params.id } })
            }
        },

        catchAxios(error){
            console.log(error);
        },
        
        openCreate(){
            this.dialogCreateVisible = true;
        },
        
        submitForm(formName) {
			this.$refs[formName].validate((valid) => {
			if (valid) {
				
				this.loadingForm = true;
                axios({
                    method: 'post',
                    url: '/server/teams.php?action=register',
                    data: {
                        name: this.createTeamForm.name,
                        tag: this.createTeamForm.tag,
                        color: this.createTeamForm.color.replace('#',''),
                        size: this.createTeamForm.size,
                        privacy: this.createTeamForm.privacy
                    }
                }).then((response) => {
                    if(response.data.error != 0){
                        this.$notify.error({
                            title: 'Error',
                            message: response.data.message,
                            offset: 115
                        });
                    } else {
                        this.dialogCreateVisible = false;
                        this.loadTeams();
                        this.resetForm(formName);
                    }
                })
                .catch(this.catchAxios)
                .then(() => {
                    this.loadingForm = false;
                });
				
				//console.log(this.$route.query);
			} else {
				this.$notify.error({
					title: 'Error',
					message: 'Campos incorrectos',
					offset: 115
				});
				return false;
			}
			});
		},
		resetForm(formName) {
			this.$refs[formName].resetFields();
		},

        joinTeam(){

        }
    },
    computed: {
        
    },
    
}
</script>

<style scoped>
    .contest-container {
        padding-top: 30px;
    }

    .contest {
        background-color: #222933CC;
        border-color: gray;
        border-left: solid 1px;
        border-right: solid 1px;
        border-top: solid 1px;
        border-bottom: solid 1px;
        position: relative;
        padding-bottom: 30px;
        margin-bottom: 50px;
    }    

	.image-container {
        height: 200px;
        width: 200px;
        border-top-left-radius: 50%;
        border-top-right-radius: 50%;
        border-top: 0;
        border-left: 0;
        border-right: 0;
        border-bottom: 0;
        position: absolute;
        left: calc(50% - 100px);
        top: -100px;
    }

    .image-container .outline {
        position: absolute;
        height: 100px;
        left: -1px;
        top: -1px;
        border-top-left-radius: 10000px;
        border-top-right-radius: 10000px;
        border: 1px solid #fff;
        border-bottom: 0;
    }

    .image-container > div {
        height: 200px;
        width: 200px;
        border-radius: 50%;
        transform: scale(1);
        transition: border-bottom-left-radius .4s ease-in-out, border-bottom-right-radius .4s ease-in-out;
        overflow: hidden;
        cursor: pointer;
    }

    .image-container > div > img {
        transform: scale(1);
        transition: transform .4s ease-in-out, filter .4s ease-in-out;
    }

    .image-container div .join {
        width: 100%;
        opacity: 0;
        font-weight: bold;
        position: absolute;
        text-align: center;
        top: calc(50% - 0.5em);
        transition: opacity .4s ease-in-out .3s;
    }
    
    .image-container > div:hover .join {
        opacity: 1;
    }

    .image-container > div:hover {
        border-bottom-left-radius: 0%;
        border-bottom-right-radius: 0%;
    }

    .image-container > div:hover > img {
        transform: scale(1.1);
        filter: blur(2px) grayscale(60%);
    }

    .img {

    }

    .img.expired {
        -webkit-filter: grayscale(100%); /* Safari 6.0 - 9.0 */
        filter: grayscale(100%);
    }
    
    .title {
        text-transform: uppercase;
        letter-spacing: 3px;
        font-weight: lighter;
        font-size: 22px;
        margin-top: 35px;
        color: #ffb70a;
    }

    .short-desc {
        font-size: 12px;
        color: #ffd777;
    }

    .participants {
        position: absolute;
        top: 0px;
        left: 0px;
        font-weight: bolder;
        font-size: 10px;
        padding: 10px;
    }

    .types {
        position: absolute;
        text-transform: uppercase;
        top: 0px;
        right: 0px;
        font-weight: bolder;
        font-size: 10px;
        padding: 10px;
    }

    .types>span:nth-child(1):before {
        content: "";
        border-left: none !important;
        padding-right: 3px;
    }

    .types>span:nth-child(n+1):before {
        content: "";
        border-left: 1px solid #DDD;
        padding-right: 3px;
    }

    .imgs {
        padding: 40px;
    }

    .body {
        text-align: justify;
        padding: 40px;
    }

    .join {
        width: 60%;
    }

    .footer {
        position: absolute;
        bottom: 0px;
        right: 0px;
    }

    .date {
        font-size: 10px;
        padding: 5px;
        color: gray;
    }
</style>